import { Timeline } from "../Timeline";
import App from "../App";
import { TweenVars, TweenCallbackType, Tween } from "../Tween";
import { AnimatedSprite } from "pixi.js";

export default class PromiseHelpers {
    public static combineParallel<T>(promises: Promise<T>[]): Promise<T> {
        return new Promise((res) => {
            let promisesLeft = promises.length || 0;
            let resolve = () => {
                promisesLeft--;
                if (promisesLeft <= 0) {
                    res();
                }
            };
            if (!promisesLeft) {
                resolve();
            } else {
                promises.forEach((promise) => {
                    promise.then(() => {
                        resolve();
                    });
                });
            }
        });
    }

    public static tweenPromise<T>(
        target,
        duration,
        vars: TweenVars
    ): Promise<T> {
        return new Promise((res) => {
            if (vars.onComplete) {
                let oldOnComplete = vars.onComplete;
                vars.onComplete = () => {
                    oldOnComplete();
                    res();
                };
            } else {
                vars["onComplete"] = () => {
                    res();
                };
            }
            App.timeline.to(target, duration, vars, App.timeline.time);
        });
    }

    /**
     * Converts a tween to promise.
     *
     * @static
     * @template T
     * @param {Tween} tween The tween to convert
     * @param {boolean} [autokill=true] Pass true to kill the tween on complete.
     * @return {*}  {Promise<T>} Awaitable promise.
     * @memberof PromiseHelpers
     */
    public static tweenToPromise<T>(tween: Tween, autokill: boolean = true): Promise<T> {
        if (!tween) {
            return this.getFakePromise();
        };
        return new Promise((resolve) => {
            tween.eventCallback(TweenCallbackType.onComplete, () => {
                if (autokill) {
                    tween.progress = 1.0;
                    tween.kill();
                    tween = undefined;
                }

                resolve();
            });
        })
    }

    /**
     * Converts a timeline to promise.
     *
     * @static
     * @template T
     * @param {Timeline} timeLine The timeline to convert
     * @param {boolean} [autokill=true] Pass true to kill the timeline on complete.
     * @return {*}  {Promise<T>} Awaitable promise.
     * @memberof PromiseHelpers
     */
    public static timelinePromise<T>(timeLine: Timeline, autokill: boolean = true): Promise<T> {
        return new Promise((resolve) => {
            timeLine.eventCallback(TweenCallbackType.onComplete, () => {
                if (autokill && timeLine) {
                    timeLine.progress = 1.0;
                    timeLine.kill();
                    timeLine = undefined;
                }

                resolve();
            });
        })
    }

    public static animPromise<T>(
        anim: AnimatedSprite,
        loop = false
    ): Promise<T> {
        return new Promise((res) => {
            anim.loop = loop;
            anim.gotoAndPlay(0);
            if(loop) {
                anim.onLoop = () => {
                    res();
                };
            } else {

                anim.onComplete = () => {
                    res();
                };
            }

        });
    }
    public static getFakePromise<T>(delay: number = 0.1): Promise<T> {
        return new Promise<T>((resolve) => {
            Tween.delayedCall(delay, () => {
                resolve();
            });
        });
    }
}
